import MetaDatatable from '@/models/MetaDatatable';
import {
    getUsers,
    getPrograms,
    getCompanies,
    getProgramsPrescriber,
    getCustomersPrescriber,
    searchPromotorsPrescriber,
    getBookingOperators,
    getOptionOperators,
    getDenounceOperators,
    getCustomers,
} from '@/api/api';
import axios from 'axios';

import User from '@/models/User';
import Program from '@/models/Program';
import Company from '@/models/Company';
import Customer from '@/models/Customer';
import regions from '@/data/regions';
import departments from '@/data/departments';
import { City } from '@/data/cities';

async function fetchPrescriber(value: string, filter: any = null) {
    const metaPrescriber: MetaDatatable = {
        total: 0,
        pages: 0,
        page: 0,
        perPage: 5,
        search: value,
        orderBy: null,
        orderWay: null,
        filters: {
            role: 'ROLE_PRESCRIBER',
        },
        exclusions: null,
    };
    metaPrescriber.filters = { ...metaPrescriber.filters, ...filter };
    const resp = await getUsers(metaPrescriber);
    return resp.data.data.map((item: User) => ({
        value: item.id,
        text: `${item.lastname} ${item.firstname}`,
    }));
}

async function fetchPrescriberSubscribed(value: string, filter: any = null) {
    const metaPrescriber: MetaDatatable = {
        total: 0,
        pages: 0,
        page: 0,
        perPage: 10,
        search: value,
        orderBy: null,
        orderWay: null,
        filters: {
            role: 'ROLE_PRESCRIBER',
            is_subscription_active: true
        },
        exclusions: null,
    };
    if (filter && typeof filter === 'object') {
    // Exclure les filtres qui ne concernent pas les utilisateurs
    const { year, years, startDate, endDate, invoiceTypes, amountRange, ...userFilters } = filter;
    metaPrescriber.filters = { ...metaPrescriber.filters, ...userFilters };
}
    const resp = await getUsers(metaPrescriber);
    return resp.data.data.map((item: User) => ({
        value: item.id,
        text: `${item.lastname} ${item.firstname}`,
    }));
}

async function fetchPrograms(value: string, filter: any = null) {
    const metaProgram: MetaDatatable = {
        total: 0,
        pages: 0,
        page: 0,
        perPage: 5,
        search: value,
        orderBy: null,
        orderWay: null,
        filters: filter,
    };

    const resp = await getPrograms(metaProgram);
    return resp.data.data.map((item: Program) => ({
        value: item.id,
        text: item.name,
    }));
}


async function fetchProgramsPrescriber(value: string, meta?: any) {
    if (value.length < 3) {
      return [];
    }
  
    console.log("META IN FETCH:", meta);

    const metaProgram: MetaDatatable = {
      total: 0,
      pages: 0,
      page: 0,
      perPage: 20,
      search: value,
      orderBy: 'updated_at',  // ✅ Sort by updated_at
      orderWay: 'desc',        // ✅ Descending (most recent first)
      filters: {
        statusProgram: AuthModule.roles.includes("ROLE_MANAGER")
          ? ["to_control", "data_processing", "diffused"]
          : ['diffused', 'sold'],
      },
    };
  
    if (meta) {
      metaProgram.filters = {...metaProgram.filters, ...meta.filters};
      console.log("COMBINED FILTERS:", metaProgram.filters);

      if (meta.operators) {
        metaProgram.operators = meta.operators;
      }
    }

    if (meta && meta.filters && meta.filters.includeProfitabilityMin) {
        const profitabilityValue = meta.filters.profitabilityMin;
        console.log("PROFITABILITY FILTER DETECTED:", {
            raw: profitabilityValue,
            type: typeof profitabilityValue,
            parsed: Number(profitabilityValue),
            includeNC: meta.filters.includeNoProfitability
        });
        
        if (profitabilityValue !== null && 
            profitabilityValue !== undefined && 
            profitabilityValue !== '' &&
            Number(profitabilityValue) <= 30) {
            
            metaProgram.filters.profitabilityMin = Number(profitabilityValue);
            console.log("Set profitabilityMin to:", metaProgram.filters.profitabilityMin);
        } else if (Number(profitabilityValue) > 30) {
            console.log("Profitability value exceeds maximum (30), not applying filter");
        }
        
        if (meta.filters.includeNoProfitability) {
            metaProgram.filters.includeNoProfitability = true;
        }
    }
    
    const resp = await getProgramsPrescriber(metaProgram);
    console.log("API RESPONSE (data count):", resp.data.data.length);
    

    const programs = resp.data.data;

  
    interface ProgramGroup {
      [key: string]: Program[];
    }
  
    // Group programs by "name + promoter"
    const groupedPrograms: ProgramGroup = programs.reduce((acc: ProgramGroup, program: Program) => {
      const key = `${program.name}__${program.promoter.name}`;
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(program);
      return acc;
    }, {});
  
    const uniquePrograms: Program[] = [];
    
    Object.keys(groupedPrograms).forEach((key) => {
        const group = groupedPrograms[key];
        
        // Sort by updated_at descending within each group to prioritize most recent
        group.sort((a, b) => getUpdatedAtTs(b) - getUpdatedAtTs(a));
        
        // Priority 1: diffused programs (all of them, sorted by most recent)
        const diffusedPrograms = group.filter(program => program.status === 'diffused');
        if (diffusedPrograms.length > 0) {
            uniquePrograms.push(...diffusedPrograms);
            return;
        }
        
        // Priority 2: other non-sold statuses (if MANAGER)
        const nonSoldPrograms = group.filter(program => program.status !== 'sold');
        if (nonSoldPrograms.length > 0) {
            uniquePrograms.push(...nonSoldPrograms);
            return;
        }
        
        // Priority 3: sold (as last resort, most recent first)
        uniquePrograms.push(...group);
    });
  
    // Sort final results by updated_at to show most recent programs first overall
    uniquePrograms.sort((a, b) => getUpdatedAtTs(b) - getUpdatedAtTs(a));
  
    return uniquePrograms.map((item: Program) => {
      // Add icon based on status
      const icon = item.status === 'sold' ? '✗' : '✓';
      
      return {
        value: item,
        text: `${icon} ${item.name} (${item.promoter.name})`,
      };
    });
}



async function fetchProgramOperatorPrescriber(value: string) {
    if (value.length < 3) {
        return []
    }

    const metaProgram: MetaDatatable = {
        total: 0,
        pages: 0,
        page: 0,
        perPage: 1,
        operator: value,
        search: '',
        orderBy: null,
        orderWay: null,
        filters: {
            statusProgram: AuthModule.roles.includes("ROLE_MANAGER") ? ["to_control", "data_processing", "diffused"] : ['diffused', 'sold'],
        },
    };
    const resp = await getProgramsPrescriber(metaProgram);
    return resp.data.data.map((item: Program) => ({
        value: item,
        text: item.manager_operator,
    }));
}

async function fetchPromotors(value: string, filter: any = null) {
    const metaPromotor: MetaDatatable = {
        total: 0,
        pages: 0,
        page: 0,
        perPage: 15,
        search: value,
        orderBy: null,
        orderWay: null,
        filters: filter,
    };
    const resp = await getCompanies(metaPromotor);
    return resp.data.data.map((item: Company) => ({
        value: item.id,
        text: item.name,
    }));
}

async function fetchPromotorsPrescriber(value: string) {
    if (value.length < 3) {
        return []
    }

    const resp = await searchPromotorsPrescriber(value);
    // Already sorted server-side from the most to the least diffused programs.
    return resp.data.map((item: Company) => ({
        value: item.id,
        text: item.name,
        nbProgrammesDiffuses: item.nb_total_programs_diffused || 0,
    }));
}

function getUpdatedAtTs(p: any): number {
  // On vérifie les deux cas au cas où le sérialiseur change
  const date = p.updatedAt || p.updated_at; 
  if (!date) return 0;
  const t = new Date(date).getTime();
  return isNaN(t) ? 0 : t;
}

async function fetchProspectsPrescriber(value: string) {
    const metaProgram: MetaDatatable = {
        total: 0,
        pages: 0,
        page: 0,
        perPage: 100,
        search: value,
        orderBy: null,
        orderWay: null,
        filters: null,
    };
    const resp = await getCustomersPrescriber(metaProgram);
    return resp.data.data.map((item: Customer) => {
        if (item.civility === 'M.' || item.civility === 'Mme.') {
            return {
                value: item.id,
                text: `${item.first_lastname} ${item.first_firstname}`,
            };
        } else if (
            item.civility === 'M. et Mme.' ||
            item.civility === 'M. et M.' ||
            item.civility === 'Mme. et Mme.'
        ) {
            return {
                value: item.id,
                text: `${item.first_lastname} ${item.first_firstname} - ${item.second_lastname} ${item.second_firstname}`,
            };
        } else if (item.civility === 'Société') {
            return {
                value: item.id,
                text: `${item.company_name}`,
            };
        }
    });
}

async function fetchOperatorsBooking(value: string) {
    // We need a special endpoint that gets users who are actually operators in bookings
    // This should call a new API endpoint that finds distinct operators from the booking table
    const resp = await getBookingOperators(value);
    return resp.data.map((item: User) => ({
        value: item.id,
        text: `${item.lastname} ${item.firstname}`,
    }));
}

async function fetchOperatorsOption(value: string) {
    const resp = await getOptionOperators(value);
    return resp.data.map((item: User) => ({
        value: item.id,
        text: `${item.lastname} ${item.firstname}`,
    }));
}


async function fetchOperatorsDenounce(value: string) {
    const resp = await getDenounceOperators(value);
    return resp.data.map((item: User) => ({
        value: item.id,
        text: `${item.lastname} ${item.firstname}`,
    }));
}





async function fetchProgramsBooking(value: string) {
    return fetchPrograms(value, { isBooking: 'yes' })
}
async function fetchPrescriberBooking(value: string) {
    return fetchPrescriber(value, { isBooking: 'yes' });
}

async function fetchPromotorsBooking(value: string) {
    return fetchPromotors(value, { isBooking: 'yes' })
}

async function fetchProspectsAdminBooking(value: string) {
    return fetchProspectsAdmin(value, { isBooking: 'yes' })
}

async function fetchProspectsAdminOption(value: string) {
    return fetchProspectsAdmin(value, { isOptionned: 'yes' })
}

async function fetchPrescriberOption(value: string) {
    return fetchPrescriber(value, { isOptionned: 'yes' })
}

async function fetchProgramOption(value: string) {
    return fetchPrograms(value, { isOptionned: 'yes' })
}

async function fetchProspectsAdminDenounce(value: string) {
    return fetchProspectsAdmin(value, { isDenounced: 'yes' })
}

async function fetchPrescriberDenounce(value: string) {
    return fetchPrescriber(value, { isDenounced: 'yes' })
}

async function fetchProgramDenounce(value: string) {
    return fetchPrograms(value, { isDenounced: 'yes' })
}




async function fetchProgramsPrescriberById(value: string, meta?: any) {
    // Si la valeur est vide, on ne retourne rien
    if (!value) {
      return [];
    }
  
    const metaProgram: MetaDatatable = {
      total: 0,
      pages: 0,
      page: 0,
      perPage: 10,       // RÈGLE 2: Affiche que 10 programmes
      search: '',        // On vide la recherche textuelle globale pour éviter de chercher dans le nom
      orderBy: 'id',     // RÈGLE 3: Trie sur la colonne ID
      orderWay: 'asc',   // RÈGLE 3: Du plus petit au plus grand
      filters: {
        id: value,       // RÈGLE 1: Envoie "34". Le backend devrait interpréter cela comme un "commence par" ou "contient"
        statusProgram: AuthModule.roles.includes("ROLE_MANAGER")
          ? ["to_control", "data_processing", "diffused"]
          : ['diffused', 'sold'],
      },
    };
  
    // Fusion des filtres existants (pays, département, etc.) si nécessaire
    if (meta) {
      // On garde les autres filtres mais on s'assure que l'ID reste celui tapé
      metaProgram.filters = {...metaProgram.filters, ...meta.filters};
      metaProgram.filters.id = value;

      if (meta.operators) {
        metaProgram.operators = meta.operators;
      }
    }

    // Gestion de la rentabilité (identique à l'existant)
    if (meta && meta.filters && meta.filters.includeProfitabilityMin) {
        const profitabilityValue = meta.filters.profitabilityMin;
        
        if (profitabilityValue !== null && 
            Number(profitabilityValue) <= 30) {
            metaProgram.filters.profitabilityMin = Number(profitabilityValue);
        }
        
        if (meta.filters.includeNoProfitability) {
            metaProgram.filters.includeNoProfitability = true;
        }
    }
    
    // Appel API
    const resp = await getProgramsPrescriber(metaProgram);

    // Si pas de données, on renvoie tableau vide
    if (!resp.data || !resp.data.data) {
        return [];
    }

    const programs = resp.data.data;
  
    // On mappe directement les résultats car l'API a déjà fait le tri (orderBy: 'id', orderWay: 'asc')
    return programs.map((item: Program) => {
      const icon = item.status === 'sold' ? '✗' : '✓';
      
      // On met l'ID en premier dans l'affichage pour confirmer visuellement
      return {
        value: item,
        text: `(ID: ${item.id}) ${icon} ${item.name} - ${item.promoter.name}`,
      };
    });
}





async function fetchProspectsAdmin(value: string, filter: any = null) {
    const metaProgram: MetaDatatable = {
        total: 0,
        pages: 0,
        page: 0,
        perPage: 5,
        search: value,
        orderBy: null,
        orderWay: null,
        filters: filter,
    };
    const resp = await getCustomers(metaProgram);
    return resp.data.data.map((item: Customer) => {
        if (item.civility === 'M.' || item.civility === 'Mme.') {
            return {
                value: item.id,
                text: `${item.first_lastname} ${item.first_firstname}`,
            };
        } else if (
            item.civility === 'M. et Mme.' ||
            item.civility === 'M. et M.' ||
            item.civility === 'Mme. et Mme.'
        ) {
            return {
                value: item.id,
                text: `${item.first_lastname} ${item.first_firstname} - ${item.second_lastname} ${item.second_firstname}`,
            };
        } else if (item.civility === 'Société') {
            return {
                value: item.id,
                text: `${item.company_name}`,
            };
        }
    });
}

import { optionStatus } from '@/data/optionStatus'
import AuthModule from '@/store/AuthModule';

async function fetchStatus(value: string) {
    const test = Object.entries(optionStatus).map(([key, val]) => {
        return { value: key, text: val }
    })
    return test
}




interface UnifiedLocation {
    value: any;
    text: string;
    type: 'Region' | 'Departement' | 'Ville' | 'Code postal';
    postalCode?: string;
    cityCode?: string;
    departmentCode?: string;
}





// filters.ts - Update fetchUnifiedLocations to ensure correct data structure

async function fetchUnifiedLocations(input: string): Promise<UnifiedLocation[]> {
    if (!input || input.trim().length < 2) {
        return [];
    }

    const searchTerm = input.toLowerCase().trim();
    const results: UnifiedLocation[] = [];

    const normalizeString = (str: string) => {
        return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    };

    const normalizedSearch = normalizeString(searchTerm);
    const isNumeric = /^\d+$/.test(searchTerm);

    const matchedDept = departments.find(d => d.code.toLowerCase() === searchTerm.toLowerCase());

    // Regions
    regions.forEach(region => {
        const normalizedName = normalizeString(region.name);
        const normalizedSlug = normalizeString(region.slug);
        
        if (normalizedName.includes(normalizedSearch) || 
            normalizedSlug.includes(normalizedSearch) ||
            region.code.toLowerCase().includes(searchTerm)) {
            results.push({
                value: region.code, // Send region code
                text: region.name,
                type: 'Region'
            });
        }
    });

    // Departments
    departments.forEach(dept => {
        const normalizedName = normalizeString(dept.name);
        if (dept.code.toLowerCase().startsWith(searchTerm) || normalizedName.includes(normalizedSearch)) {
            results.push({
                value: dept.code, // Send department code
                text: `${dept.name} ${dept.code}`,
                type: 'Departement',
                departmentCode: dept.code
            });
        }
    });

    // Postal Code
    if (isNumeric && searchTerm.length >= 2 && searchTerm.length <= 5) {
        let padded = searchTerm;
        while (padded.length < 5) padded += '0';
        results.push({
            value: padded, // Send postal code
            text: `${padded} (toutes les villes)`,
            type: 'Code postal',
            postalCode: padded
        });
    }

    // Cities
    try {
        let citiesData: any[] = [];
        
        if (matchedDept) {
            const response = await axios.get(`https://geo.api.gouv.fr/communes`, {
                params: {
                    codeDepartement: matchedDept.code,
                    fields: 'nom,code,codesPostaux,population',
                    boost: 'population', 
                    limit: 50 
                }
            });
            
            citiesData = response.data.map((c: any) => ({
                name: c.nom,
                zip: c.codesPostaux ? c.codesPostaux[0] : c.code,
                code: c.code,
                pop: c.population || 0
            }));
            
            citiesData.sort((a, b) => b.pop - a.pop);

        } else {
            if (isNumeric && searchTerm.length >= 4) {
                const response = await axios.get(`https://geo.api.gouv.fr/communes`, {
                    params: {
                        codePostal: searchTerm,
                        fields: 'nom,code,codesPostaux,population',
                        boost: 'population',
                        limit: 20
                    }
                });
                citiesData = response.data.map((c: any) => ({
                    name: c.nom,
                    zip: searchTerm,
                    code: c.code,
                    pop: c.population
                }));
                citiesData.sort((a, b) => b.pop - a.pop);
            } else {
                if(input.length >= 3) {
                    const response = await axios.get(`https://api-adresse.data.gouv.fr/search/`, {
                        params: {
                            q: input,
                            type: 'municipality',
                            limit: 20,
                            autocomplete: 1
                        }
                    });
                    if (response.data && response.data.features) {
                        citiesData = response.data.features.map((f: any) => ({
                            name: f.properties.city,
                            zip: f.properties.postcode,
                            code: f.properties.citycode,
                            pop: 0 
                        }));
                    }
                }
            }
        }

        citiesData.forEach((city: any) => {
            results.push({
                value: city.name, // IMPORTANT: Send city NAME, not code
                text: `${city.name} (${city.zip.substring(0, 2)})`,
                type: 'Ville',
                postalCode: city.zip,
                cityCode: city.code,
                departmentCode: city.zip ? city.zip.substring(0, 2) : ''
            });
        });

    } catch (error) {
        console.error('City fetch error:', error);
    }

    // Sort and return
    const typeDept = results.filter(r => r.type === 'Departement');
    const typeRegion = results.filter(r => r.type === 'Region');
    const typeZip = results.filter(r => r.type === 'Code postal');
    const typeCity = results.filter(r => r.type === 'Ville');

    const final: UnifiedLocation[] = [];

    typeDept.sort((a, b) => {
        const aExact = a.value.toString() === input;
        const bExact = b.value.toString() === input;
        if (aExact && !bExact) return -1;
        if (!aExact && bExact) return 1;
        return 0;
    });
    
    final.push(...typeDept);
    final.push(...typeZip);

    if (!isNumeric) {
        final.push(...typeRegion);
    }

    final.push(...typeCity);
    
    if (isNumeric) {
        final.push(...typeRegion);
    }

    const unique: UnifiedLocation[] = [];
    const keys = new Set();
    for(const item of final) {
        const k = `${item.type}-${item.value}-${item.text}`;
        if(!keys.has(k)){
            keys.add(k);
            unique.push(item);
        }
    }

    return unique.slice(0, 50);
}







export {
    fetchPrescriber,
    fetchPrescriberSubscribed,
    fetchPrescriberBooking,
    fetchPrograms,
    fetchProgramsBooking,
    fetchPromotors,
    fetchPromotorsBooking,
    fetchProgramsPrescriber,
    fetchProspectsPrescriber,
    fetchProspectsAdmin,
    fetchProspectsAdminBooking,
    fetchPromotorsPrescriber,
    fetchStatus,
    fetchPrescriberDenounce,
    fetchPrescriberOption,
    fetchProgramDenounce,
    fetchProgramOption,
    fetchProspectsAdminDenounce,
    fetchProspectsAdminOption,
    fetchOperatorsBooking,
    fetchOperatorsOption,
    fetchOperatorsDenounce,
    fetchProgramsPrescriberById,
    fetchProgramOperatorPrescriber,
    fetchUnifiedLocations
};